import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { AiAssessedScore } from '../frontendServices/gameAPI';
import { SocketContext } from '../providers/SocketProvider/SocketProvider';

const useEditAiAssessedScore = (
  gameId: string,
  slideId: string,
  tenantId: string,
  responseId: string,
  editedFeedback?: string,
) => {
  const { gameAPI } = useContext(SocketContext);
  const client = useQueryClient();
  const scoresCacheKey = ['aiAssessedScores', gameId, slideId];
  const {
    mutate: saveEditedAiAssessedSingleScore,
    data: newAiAssessedScore,
    isLoading: isSavingSingle,
  } = useMutation(
    scoresCacheKey,
    async () => {
      if (!gameAPI || !editedFeedback) return Promise.resolve(undefined);
      return gameAPI.game.aiAssessEditFeedback({
        gameId,
        slideId,
        tenantId,
        responseId,
        editedFeedback,
      });
    },
    {
      onSuccess: newAiAssessedScore => {
        client.setQueryData<AiAssessedScore[] | undefined>(
          scoresCacheKey,
          previousScores => {
            if (!previousScores || !newAiAssessedScore) return previousScores;
            const updatedAiScores = previousScores.map(oldScore => {
              const newScore = newAiAssessedScore.result.find(
                r => r.responseId === oldScore.responseId,
              );

              return newScore || oldScore;
            });
            return updatedAiScores;
          },
        );
      },
      retry: 3,
      retryDelay: 400,
    },
  );

  return {
    saveEditedAiAssessedSingleScore,
    editedAiAssessedScoreSingle: newAiAssessedScore?.result[0],
    isSavingSingle,
  };
};

export default useEditAiAssessedScore;
